var _g, _defs, _g2, _clipPath, _use, _g3, _g4, _clipPath2, _use2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    height: 28,
    id: "screenshot-2e67213e-0494-80dd-8007-4783489f6c2c",
    viewBox: "0 0 28 28",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-2e67213e-0494-80dd-8007-4783489f6c2c"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-blur"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-shadows"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2e67213e-0494-80dd-8007-4783489f6c2c"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 27.000000000000114,
    height: 28,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "frame-background"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-2e67213e-0494-80dd-8007-4783489ff43d"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "frame-clip-2e67213e-0494-80dd-8007-4783489ff43d-render-2",
    className: "frame-clip frame-clip-def"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 28.000000000000114,
    height: 27.899999999999636,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "frame-container-wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-blur"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-shadows"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#frame-clip-2e67213e-0494-80dd-8007-4783489ff43d-render-2)",
    fill: "none"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2e67213e-0494-80dd-8007-4783489ff43d"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 28.000000000000114,
    height: 27.899999999999636,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "frame-background"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-2e67213e-0494-80dd-8007-4783489ff43e",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2e67213e-0494-80dd-8007-4783489ff43e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.10035842293894,
    height: 28,
    x: 0.22547712387768115,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none"
    },
    ry: 0,
    fill: "none",
    rx: 0,
    y: 0.24481429956904321
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    id: "strokes-1bb23553-35f3-809d-8007-478368211a95-2e67213e-0494-80dd-8007-4783489ff43e",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape",
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-3-2e67213e-0494-80dd-8007-4783489ff43e-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-3-2e67213e-0494-80dd-8007-4783489ff43e-0"
  }))), /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0.22547712387768115,
    y: 0.24481429956904321,
    width: 28.10035842293894,
    height: 28,
    id: "stroke-shape-render-3-2e67213e-0494-80dd-8007-4783489ff43e-0",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(247, 242, 240)",
      strokeOpacity: 1
    }
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-3-2e67213e-0494-80dd-8007-4783489ff43e-0",
    clipPath: "url('#inner-stroke-render-3-2e67213e-0494-80dd-8007-4783489ff43e-0')"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "shape-2e67213e-0494-80dd-8007-478348a01935"
  }, /*#__PURE__*/React.createElement("style", null, "#shape-{ .st0{fill:#4487C7;}\r\n\t.st1{fill:none;stroke:#4487C7;stroke-miterlimit:10;} }"))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2e67213e-0494-80dd-8007-478348a01937"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2e67213e-0494-80dd-8007-478348a01937"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.27557373046875,6.86865234375C13.27203369140625,6.86865234375,12.36883544921875,7.27001953125,11.66619873046875,7.972412109375C10.96380615234375,8.675048828125,10.56231689453125,9.578125,10.56231689453125,10.4814453125C10.56231689453125,12.488525390625,12.26849365234375,14.09423828125,14.27557373046875,14.09423828125L14.27557373046875,14.09423828125C15.27923583984375,14.09423828125,16.18243408203125,13.69287109375,16.88494873046875,12.990234375C17.58734130859375,12.287841796875,17.98895263671875,11.384765625,17.98895263671875,10.4814453125C18.08917236328125,8.47412109375,16.38311767578125,6.86865234375,14.27557373046875,6.86865234375Z",
    className: "st0",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "strokes",
    id: "strokes-1bb23553-35f3-809d-8007-478368228c52-2e67213e-0494-80dd-8007-478348a01937"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.27557373046875,6.86865234375C13.27203369140625,6.86865234375,12.36883544921875,7.27001953125,11.66619873046875,7.972412109375C10.96380615234375,8.675048828125,10.56231689453125,9.578125,10.56231689453125,10.4814453125C10.56231689453125,12.488525390625,12.26849365234375,14.09423828125,14.27557373046875,14.09423828125L14.27557373046875,14.09423828125C15.27923583984375,14.09423828125,16.18243408203125,13.69287109375,16.88494873046875,12.990234375C17.58734130859375,12.287841796875,17.98895263671875,11.384765625,17.98895263671875,10.4814453125C18.08917236328125,8.47412109375,16.38311767578125,6.86865234375,14.27557373046875,6.86865234375Z",
    style: {
      fill: "none",
      strokeWidth: 0,
      stroke: "rgb(229, 125, 46)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2e67213e-0494-80dd-8007-478348a01938"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2e67213e-0494-80dd-8007-478348a01938"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.18963623046875,14.19482421875C17.98895263671875,13.993896484375,17.58734130859375,13.993896484375,17.28631591796875,14.19482421875C17.28631591796875,14.19482421875,14.27557373046875,16.5029296875,11.56585693359375,14.19482421875C11.26483154296875,13.993896484375,10.96380615234375,13.993896484375,10.66265869140625,14.19482421875C10.56231689453125,14.294921875,7.95306396484375,16.70361328125,7.85272216796875,21.42041015625C7.85272216796875,21.62109375,7.95306396484375,21.82177734375,8.05340576171875,21.92236328125C8.15374755859375,22.0224609375,8.35443115234375,22.123046875,8.55511474609375,22.123046875L19.99603271484375,22.123046875C20.39739990234375,22.123046875,20.69854736328125,21.82177734375,20.69854736328125,21.42041015625C20.69854736328125,21.2197265625,20.79888916015625,16.803955078125,18.18963623046875,14.19482421875Z",
    className: "st0",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "strokes",
    id: "strokes-1bb23553-35f3-809d-8007-478368231b9e-2e67213e-0494-80dd-8007-478348a01938"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.18963623046875,14.19482421875C17.98895263671875,13.993896484375,17.58734130859375,13.993896484375,17.28631591796875,14.19482421875C17.28631591796875,14.19482421875,14.27557373046875,16.5029296875,11.56585693359375,14.19482421875C11.26483154296875,13.993896484375,10.96380615234375,13.993896484375,10.66265869140625,14.19482421875C10.56231689453125,14.294921875,7.95306396484375,16.70361328125,7.85272216796875,21.42041015625C7.85272216796875,21.62109375,7.95306396484375,21.82177734375,8.05340576171875,21.92236328125C8.15374755859375,22.0224609375,8.35443115234375,22.123046875,8.55511474609375,22.123046875L19.99603271484375,22.123046875C20.39739990234375,22.123046875,20.69854736328125,21.82177734375,20.69854736328125,21.42041015625C20.69854736328125,21.2197265625,20.79888916015625,16.803955078125,18.18963623046875,14.19482421875Z",
    style: {
      fill: "none",
      strokeWidth: 0,
      stroke: "rgb(255, 255, 255)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2e67213e-0494-80dd-8007-478348a01939"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2e67213e-0494-80dd-8007-478348a01939"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.27565633534715,
    cy: 14.495710356916788,
    rx: 12.845878136200838,
    ry: 12.845878136200554,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "st1"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "strokes",
    id: "strokes-1bb23553-35f3-809d-8007-478368239def-2e67213e-0494-80dd-8007-478348a01939"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape",
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-7-2e67213e-0494-80dd-8007-478348a01939-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-7-2e67213e-0494-80dd-8007-478348a01939-0"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.27565633534715,
    cy: 14.495710356916788,
    rx: 12.845878136200838,
    ry: 12.845878136200554,
    id: "stroke-shape-render-7-2e67213e-0494-80dd-8007-478348a01939-0",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(255, 255, 255)",
      strokeOpacity: 1
    }
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-7-2e67213e-0494-80dd-8007-478348a01939-0",
    clipPath: "url('#inner-stroke-render-7-2e67213e-0494-80dd-8007-478348a01939-0')"
  }))))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileW);
export default __webpack_public_path__ + "static/media/profileW.d3e4789f3541c1afd0f681a2172e0036.svg";
export { ForwardRef as ReactComponent };